export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3">
            <img src="https://static.readdy.ai/image/4b210e4d3d9fe9a73b886d10fa116566/0e64fe7d7ddf660e67742842ccecd709.png" alt="ロゴ" className="h-8 sm:h-10 w-auto" />
            <h1 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 hidden sm:block">集客・予約・広告 フル自動化パッケージ</h1>
          </div>
          <a href="/" className="px-4 sm:px-6 py-2.5 sm:py-3 bg-[#1A3A52] text-white text-sm sm:text-base rounded-lg font-medium hover:bg-[#2A4A62] transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
            トップへ戻る
          </a>
        </div>
      </header>

      {/* メインコンテンツ */}
      <main className="py-12 sm:py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-6 sm:mb-8 text-center">プライバシーポリシー</h1>
          
          <div className="bg-white rounded-xl p-6 sm:p-8 lg:p-10 shadow-lg border border-gray-200">
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-8 sm:mb-10">
              スーパースプーン（以下、「当社」といいます）は、当社が提供するサービス（以下、「本サービス」といいます）において、ユーザーの個人情報を以下の方針に基づき適切に取り扱います。
            </p>

            {/* 1. 個人情報の取得について */}
            <section className="mb-8 sm:mb-10">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-5 pb-2 border-b-2 border-[#1A3A52]">1. 個人情報の取得について</h2>
              
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                当社は、以下の場合に個人情報を取得することがあります。
              </p>

              <ul className="space-y-2 mb-5">
                {[
                  'お問い合わせフォーム・無料相談フォームの送信時',
                  'Google広告等のリードフォームを通じた情報送信時',
                  'サービス提供・ご相談対応に必要な範囲での情報提供時'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-blank-circle-fill text-xs text-[#1A3A52]"></i>
                    </div>
                    <span className="text-sm sm:text-base text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>

              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                取得する情報には、以下が含まれる場合があります。
              </p>

              <ul className="space-y-2">
                {[
                  '氏名',
                  'メールアドレス',
                  '電話番号',
                  '会社名・屋号',
                  'その他お問い合わせ内容に含まれる情報'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-blank-circle-fill text-xs text-[#1A3A52]"></i>
                    </div>
                    <span className="text-sm sm:text-base text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </section>

            {/* 2. 個人情報の利用目的 */}
            <section className="mb-8 sm:mb-10">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-5 pb-2 border-b-2 border-[#1A3A52]">2. 個人情報の利用目的</h2>
              
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                取得した個人情報は、以下の目的の範囲内で利用します。
              </p>

              <ul className="space-y-2 mb-4">
                {[
                  'お問い合わせ・ご相談への対応',
                  'サービス内容のご案内およびご提案',
                  'サービス提供・運営・改善のため',
                  '必要に応じたご連絡',
                  '不正行為や利用規約違反への対応'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-blank-circle-fill text-xs text-[#1A3A52]"></i>
                    </div>
                    <span className="text-sm sm:text-base text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>

              <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-medium">
                上記目的以外で利用することはありません。
              </p>
            </section>

            {/* 3. 個人情報の第三者提供について */}
            <section className="mb-8 sm:mb-10">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-5 pb-2 border-b-2 border-[#1A3A52]">3. 個人情報の第三者提供について</h2>
              
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                当社は、以下の場合を除き、個人情報を第三者に提供することはありません。
              </p>

              <ul className="space-y-2 mb-3">
                {[
                  '本人の同意がある場合',
                  '法令に基づき開示が求められた場合',
                  '業務委託先（広告配信・分析・システム運用等）に、業務遂行に必要な範囲で提供する場合'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-blank-circle-fill text-xs text-[#1A3A52]"></i>
                    </div>
                    <span className="text-sm sm:text-base text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>

              <p className="text-sm text-gray-600 leading-relaxed">
                ※この場合も、適切な管理・監督を行います。
              </p>
            </section>

            {/* 4. 広告・アクセス解析ツールについて */}
            <section className="mb-8 sm:mb-10">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-5 pb-2 border-b-2 border-[#1A3A52]">4. 広告・アクセス解析ツールについて</h2>
              
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                当社は、以下のツールを利用する場合があります。
              </p>

              <ul className="space-y-2 mb-4">
                {[
                  'Google広告',
                  'Google Analytics'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-blank-circle-fill text-xs text-[#1A3A52]"></i>
                    </div>
                    <span className="text-sm sm:text-base text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>

              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                これらのツールでは、Cookie等を利用してユーザーのアクセス情報を取得することがありますが、個人を特定する情報は含まれません。
              </p>

              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Googleによるデータの取り扱いについては、以下をご参照ください。<br />
                <a 
                  href="https://policies.google.com/privacy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[#1A3A52] hover:underline cursor-pointer inline-flex items-center gap-1"
                >
                  https://policies.google.com/privacy
                  <i className="ri-external-link-line text-sm"></i>
                </a>
              </p>
            </section>

            {/* 5. 個人情報の管理について */}
            <section className="mb-8 sm:mb-10">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-5 pb-2 border-b-2 border-[#1A3A52]">5. 個人情報の管理について</h2>
              
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                当社は、個人情報の漏えい・滅失・改ざん等を防止するため、適切な安全管理措置を講じます。
              </p>
            </section>

            {/* 6. 個人情報の開示・訂正・削除について */}
            <section className="mb-8 sm:mb-10">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-5 pb-2 border-b-2 border-[#1A3A52]">6. 個人情報の開示・訂正・削除について</h2>
              
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                ご本人から、自己の個人情報について開示・訂正・削除等の請求があった場合、本人確認を行った上で、合理的な範囲で速やかに対応します。
              </p>
            </section>

            {/* 7. プライバシーポリシーの変更について */}
            <section className="mb-8 sm:mb-10">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-5 pb-2 border-b-2 border-[#1A3A52]">7. プライバシーポリシーの変更について</h2>
              
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                本ポリシーの内容は、法令の変更やサービス内容の変更等により、予告なく改定されることがあります。
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                最新の内容は本ページにて常に開示します。
              </p>
            </section>

            {/* 8. お問い合わせ窓口 */}
            <section>
              <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-5 pb-2 border-b-2 border-[#1A3A52]">8. お問い合わせ窓口</h2>
              
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4">
                個人情報の取り扱いに関するお問い合わせは、以下よりご連絡ください。
              </p>

              <div className="bg-[#F0F7F4] rounded-lg p-4 sm:p-5">
                <p className="text-sm sm:text-base text-gray-900 font-bold mb-2">スーパースプーン</p>
                <p className="text-sm sm:text-base text-gray-700">
                  お問い合わせフォーム：<br />
                  <a 
                    href="https://seitai.superspoon.net/#contact" 
                    className="text-[#1A3A52] hover:underline cursor-pointer inline-flex items-center gap-1 mt-1"
                  >
                    https://seitai.superspoon.net/#contact
                    <i className="ri-external-link-line text-sm"></i>
                  </a>
                </p>
              </div>
            </section>
          </div>

          {/* トップへ戻るボタン */}
          <div className="text-center mt-8 sm:mt-10">
            <a 
              href="/" 
              className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-3.5 bg-[#1A3A52] text-white text-sm sm:text-base rounded-lg font-medium hover:bg-[#2A4A62] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line text-lg"></i>
              <span>トップページへ戻る</span>
            </a>
          </div>
        </div>
      </main>

      {/* フッター */}
      <footer className="bg-[#1A3A52] py-10 sm:py-12">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-4 sm:mb-6">
            <a 
              href="https://superspoon.net/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white text-sm sm:text-base font-medium mb-1 inline-flex items-center gap-2 hover:text-white/80 transition-colors cursor-pointer"
            >
              <span>運営:Superspoon</span>
              <i className="ri-external-link-line text-base"></i>
            </a>
          </div>
          <div className="text-center mb-3 sm:mb-4">
            <a 
              href="/privacy" 
              className="text-white/80 text-xs sm:text-sm hover:text-white transition-colors cursor-pointer"
            >
              プライバシーポリシー
            </a>
          </div>
          <div className="text-center">
            <p className="text-white/60 text-xs">© 2025 SuperSpoon. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
